// internal imports
import { useMemo, useState } from "react";
import { useDocumentTitle, useGetService } from "../../../hooks";

// style
import "../Assignment.scss";
import { HotelPast } from "./HotelPast";
import { SelectDropdown } from "../../../components";
import { API, VendorTypeService } from "../../../constants";

interface IVendorOption {
  label: string;
  value: string;
}

// Super admin view of the hotel Past scans page: pick a hotel vendor, then
// the regular vendor-facing page runs against that vendor's scans.
export const AdminHotelPast = () => {
  useDocumentTitle("Hotel past scans");

  const [selectedVendor, setSelectedVendor] = useState<IVendorOption | null>(
    null
  );

  const { response, isLoading } = useGetService(
    `${API.REGISTRATION_REQUEST.LIST}?status=approved`
  );

  const vendorOptions: IVendorOption[] = useMemo(() => {
    const items: any[] = Array.isArray(response?.items) ? response.items : [];
    return items
      .filter(
        (vendor) => vendor?.vendorTypeName === VendorTypeService.HOTEL_ONLY
      )
      .map((vendor) => ({
        label: vendor.email ? `${vendor.name} (${vendor.email})` : vendor.name,
        value: String(vendor.id),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [response]);

  return (
    <div>
      <div style={{ maxWidth: 420, marginTop: 8 }}>
        <SelectDropdown
          label="Hotel vendor"
          placeholder={isLoading ? "Loading hotel vendors…" : "Select a hotel vendor..."}
          options={vendorOptions}
          value={selectedVendor}
          onChange={(option: any) => setSelectedVendor(option || null)}
          isLoading={isLoading}
          isClearable
        />
      </div>

      {selectedVendor ? (
        // Remount per vendor so dates, filters, loaded rows and cursors reset.
        <HotelPast key={selectedVendor.value} vendorId={selectedVendor.value} />
      ) : (
        <div
          style={{
            marginTop: 24,
            padding: 32,
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.6)",
            border: "1px dashed rgba(0, 0, 0, 0.2)",
            borderRadius: 8,
          }}
        >
          Select a hotel vendor to view their past check-in and meal scans.
        </div>
      )}
    </div>
  );
};
